// eslint-disable-next-line
import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class AgenciaTransfusional extends CoreBase implements IAgenciaTransfusional {
  async backOfficeAgenciaTransfusionalContataPaciente(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backOfficeAgenciaTransfusionalContataPaciente(params)
    return response
  }

  async backOfficeAgenciaTransfusionalRealizaColeta(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backOfficeAgenciaTransfusionalRealizaColeta(params)
    return response
  }

  async backOfficeAgenciaTransfusionalAnalisaColeta(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backOfficeAgenciaTransfusionalAnalisaColeta(params)
    return response
  }

  async backOfficeAgenciaTransfusionalRealizaTeste(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backOfficeAgenciaTransfusionalRealizaTeste(params)
    return response
  }
}

interface IAgenciaTransfusional extends ICoreBase {
  backOfficeAgenciaTransfusionalContataPaciente(params: any): Promise<ResponseApi>
  backOfficeAgenciaTransfusionalRealizaColeta(params: any): Promise<ResponseApi>
  backOfficeAgenciaTransfusionalAnalisaColeta(params: any): Promise<ResponseApi>
  backOfficeAgenciaTransfusionalRealizaTeste(params: any): Promise<ResponseApi>
}

export {
  AgenciaTransfusional,
  IAgenciaTransfusional,
}
